import { render, staticRenderFns } from "./MenuRight.vue?vue&type=template&id=04c08464&scoped=true&"
import script from "./MenuRight.vue?vue&type=script&lang=ts&"
export * from "./MenuRight.vue?vue&type=script&lang=ts&"
import style0 from "./MenuRight.vue?vue&type=style&index=0&id=04c08464&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c08464",
  null
  
)

export default component.exports